module.exports = __webpack_public_path__ + "assets/img/20211006.10c94ec4.png";